import React from "react"

// Loading component for suspense fallback
export const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-neutral-50 dark:bg-neutral-900">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    <span className="ml-3 text-lg font-medium text-neutral-800 dark:text-neutral-200">Loading...</span>
  </div>
)